import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { productsAPI } from '../api';

export default function DirectRecipeCreate({ productId, itemMaster, onCreated }) {
  const [ingredients, setIngredients] = useState([]);
  const [notes, setNotes] = useState('');
  const [itemSearch, setItemSearch] = useState('');
  const [addForm, setAddForm] = useState({ item_code: '', item_name: '', quantity: '', unit: 'kg', unit_cost: 0 });
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredItems = itemSearch.length > 1
    ? itemMaster.filter(i =>
        i.item_code?.toLowerCase().includes(itemSearch.toLowerCase()) ||
        i.item_name?.toLowerCase().includes(itemSearch.toLowerCase())
      ).slice(0, 15)
    : [];

  const selectItem = (item) => {
    setAddForm({ item_code: item.item_code, item_name: item.item_name, quantity: '', unit: item.unit||'kg', unit_cost: item.unit_cost||0 });
    setItemSearch(item.item_code + ' — ' + item.item_name);
    setShowDropdown(false);
  };

  const addIngredient = () => {
    if (!addForm.item_code || !addForm.quantity) return;
    const qty = parseFloat(addForm.quantity) || 0;
    const cost = parseFloat(addForm.unit_cost) || 0;
    setIngredients([...ingredients, { ...addForm, quantity: qty, total_cost: qty * cost, id: Date.now() }]);
    setAddForm({ item_code: '', item_name: '', quantity: '', unit: 'kg', unit_cost: 0 });
    setItemSearch('');
  };

  const [batchSize, setBatchSize] = useState('');
  const [batchUnit, setBatchUnit] = useState('kg');

  const save = async () => {
    if (ingredients.length === 0) { toast.error('Add at least one ingredient'); return; }
    if (!(parseFloat(batchSize) > 0)) { toast.error('Batch size is required'); return; }
    const userName = (() => { try { const u = JSON.parse(localStorage.getItem('npd_user')); return u?.name || u?.username || ''; } catch { return ''; } })();
    await productsAPI.saveRecipe(productId, {
      trial_id: null, notes, confirmed_by: userName, batch_size: parseFloat(batchSize), batch_unit: batchUnit,
      ingredients: ingredients.map(i => ({ item_code: i.item_code, item_name: i.item_name, quantity: i.quantity, unit: i.unit, unit_cost: i.unit_cost, total_cost: i.total_cost })),
      has_brine: false, brineIngredients: []
    });
    toast.success('Recipe created!');
    onCreated();
  };

  return (
    <div>
      <div className="flex-between mb-4">
        <div className="card-title" style={{ margin: 0 }}>Create Recipe Directly</div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <input type="number" placeholder="Batch size (required)" value={batchSize} onChange={e => setBatchSize(e.target.value)}
            style={{ width: 150, padding: '6px 10px', border: '1px solid ' + (!(parseFloat(batchSize) > 0) ? 'var(--red, #c62828)' : 'var(--border, #ccc)'), borderRadius: 6 }} />
          <select value={batchUnit} onChange={e => setBatchUnit(e.target.value)} style={{ padding: '6px 8px' }}>
            <option value="kg">kg</option><option value="g">g</option>
          </select>
          <button className="btn btn-primary" onClick={save}>✓ Save Recipe</button>
        </div>
      </div>

      {/* Item Search */}
      <div style={{ position: 'relative', marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div style={{ flex: 3, minWidth: 220, position: 'relative' }}>
            <label style={{ fontSize: 11, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Search Item (code or name)</label>
            <input
              placeholder="Type item code or name..."
              value={itemSearch}
              onChange={e => { setItemSearch(e.target.value); setShowDropdown(true); }}
              onFocus={() => setShowDropdown(true)}
              style={{ width: '100%' }}
            />
            {showDropdown && filteredItems.length > 0 && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: 6, zIndex: 100, maxHeight: 220, overflowY: 'auto', boxShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>
                {filteredItems.map(item => (
                  <div key={item.id} onClick={() => selectItem(item)} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border)', fontSize: 12 }}
                    onMouseEnter={e => e.currentTarget.style.background = 'var(--bg-hover)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <span className="mono" style={{ color: 'var(--accent)', fontSize: 11 }}>{item.item_code}</span>
                    <span style={{ marginLeft: 8, color: 'var(--text-primary)' }}>{item.item_name}</span>
                    <span className="text-muted" style={{ marginLeft: 8, fontSize: 10 }}>AED {item.unit_cost}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={{ flex: 1, minWidth: 70 }}>
            <label style={{ fontSize: 11, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Qty</label>
            <input type="number" placeholder="0" value={addForm.quantity} onChange={e => setAddForm({ ...addForm, quantity: e.target.value })} />
          </div>
          <div style={{ flex: 1, minWidth: 60 }}>
            <label style={{ fontSize: 11, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Unit</label>
            <input value={addForm.unit} onChange={e => setAddForm({ ...addForm, unit: e.target.value })} />
          </div>
          <button className="btn btn-primary btn-sm" onClick={addIngredient}>+ Add</button>
        </div>
      </div>

      {/* Ingredients table */}
      {ingredients.length > 0 && (
        <div className="table-wrap mb-4">
          <table>
            <thead><tr><th>Code</th><th>Name</th><th>Qty</th><th>Unit</th><th>Unit Cost</th><th>Total</th><th></th></tr></thead>
            <tbody>
              {ingredients.map((ing, idx) => (
                <tr key={ing.id}>
                  <td className="mono">{ing.item_code}</td>
                  <td>{ing.item_name}</td>
                  <td className="mono">{ing.quantity}</td>
                  <td>{ing.unit}</td>
                  <td className="mono">AED {ing.unit_cost}</td>
                  <td className="cost-value">AED {ing.total_cost.toFixed(2)}</td>
                  <td><button className="btn btn-danger btn-sm" onClick={() => setIngredients(ingredients.filter((_, i) => i !== idx))}>×</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="form-group">
        <label>Notes</label>
        <textarea placeholder="Recipe notes..." value={notes} onChange={e => setNotes(e.target.value)} />
      </div>
    </div>
  );
}
